import React, { Fragment } from "react";
import Countdown from "react-downcount";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';
// https://skyvow.github.io/react-wow/#/
// https://www.pexels.com/search/programming/

// const endDate = "1569887999000";

function Num2String(num) {
  const numStr = num > 9 ? Number(num).toString() : `0` + num;
  return numStr.split('');
}

const customRenderer = ({ days, hrs, mins, secs, isCompleted }) => {
  const times = [{
    value: Num2String(days),
    unit: 'DAYS'
  }, {
    value: Num2String(hrs),
    unit: 'HOURS'
  }, {
    value: Num2String(mins),
    unit: 'MINUTES'
  }, {
    value: Num2String(secs),
    unit: 'SECONDS'
  }]

  return isCompleted ? (
    ""
  ) : (
    <Fragment>
      {
        times.map((time, index) => (
          <Fragment key={time.unit}>
             { index !== 0 ?  <div className="colon">:</div> : null}
            <div className="segment">
              {  time.value.map((num, index) => <span className="number" key={num + index}>{num}</span>) }
              <p className="unit">{time.unit}</p>
            </div>
          </Fragment>
        ))
      }
    </Fragment>
  );
};

class Banner extends React.Component {
  goRegister() {
    const target = document.getElementById("register");
    target.scrollIntoView({ block: "start", behavior: "smooth" });
  }

  render() {
    const { message = {}, className } = this.props
    return (
      <section id="banner" className={className}>
        <ReactWOW animation="fadeInLeft">
          <span className="stripes left" />
        </ReactWOW>
        <ReactWOW animation="fadeInRight">
          <span className="stripes right" />
        </ReactWOW>
        <div className="content">
          <ReactWOW animation="bounceIn" delay="0.4s">
            <div className="title-wrapper">
              <span className="phone" />
              <div className="content">
                <div className="title highlight brand">Shopee</div>
                <h1 className="title">{$t(message.title)}</h1>
                <p className="title">{$t(message.sutTitle)}</p>
              </div>
            </div>
          </ReactWOW>
          <div className="time-wrapper">
            <ReactWOW animation="bounceIn" delay="0.7s">
              <p className="time-frame">{$t(message.time)}</p>
              <Countdown className="countdown" endDate={new Date($t(message.endDate))}>
                {customRenderer}
              </Countdown>
            </ReactWOW>
            <ReactWOW animation="bounceIn" delay="0.7s">
              <a className="sign-up" target="_blank" rel="noopener noreferrer" href="https://techatshopee.formstack.com/forms/productdesign_challenge2021">{$t(message.registerBtn)}</a>
            </ReactWOW>
          </div>
        </div>
      </section>
    );
  }
}

export default Banner;
